<div>
  <mat-table
    [dataSource]="pagedItems"
    matSort
    matSortActive="id"
    matSortDirection="asc"
    (matSortChange)="matsortColumn($event)"
  >
    <ng-container
      [matColumnDef]="column"
      *ngFor="let column of displayedColumns"
    >
      <mat-header-cell
        class="header-cell"
        *matHeaderCellDef
        mat-sort-header
        [disabled]="!isSortable"
        tabindex="0"
      >
        {{ column }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element"  tabindex="0">
        <ng-container *ngIf="column !== 'Action'; else actiontemp">
          {{ element[column] }}
        </ng-container>
        <ng-template #actiontemp>
          <div action-buttons (buttonAction)="onTableAction($event)"></div>
        </ng-template>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
    <mat-row
      class="mat-row-word"
      *matRowDef="let row; columns: columnsToDisplay"
    ></mat-row>
  </mat-table>
  <!-- <div class="pagination-conatiner" *ngIf="!isAccordion">
    <div style="float: left">
      <span class="show-data"
        >Showing {{ pager.startIndex + 1 }} -
        {{ pager.pageSize * pager.currentPage }} of {{ pager.totalItems }}</span
      >
    </div>
    <pagination-controls (pageChange)="setPage($event)" previousLabel=""
    nextLabel="" class="pagination-bar"  [maxSize]= "7"  [autoHide]="true"></pagination-controls>
  </div> -->
</div>
